import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddCity from "./AddCities";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import { useNavigate, useParams } from "react-router-dom";

const columns = [
  //   {
  //     id: "createdAt",
  //     label: "Created Date",
  //     minWidth: 170,
  //     sortable: true,
  //   },
  {
    id: "name",
    label: "Name",
    minWidth: 170,
    sortable: false,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as any,
  },
];

const Cities = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
    const [stateName, setStateName] = useState("");

  const { id  } = useParams();
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    name: "name",
    status: "status",
    createdAt: "createdAt",
  };
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getCities();
    getStateDetail();
  }, [currentPage, sortField, sortOrder]);

 const getStateDetail = () => {
  if (!id) return;

  WebService.getAPI({
    action: `city/detail/${id}`,
  })
    .then((res: any) => {
      setStateName(res?.data?.name || "");
    })
    .catch(() => {});
};
  const getCities = (keyword = "", typeId = "") => {
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Status filter
    if (search && search !== "ALL") {
      params.append("status", search);
    }
  if (id) {
      params.append("stateId", id);
    }
    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }
    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `city/list?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => ({
          ...item,
          //    createdAt: HelperService.getFormatedDate(item.createdAt),
          cities: (
            <a
              href="#"
              title="View Cities"
              onClick={() => navigate(`/cities/${item._id}`)}
            >
              Cities
            </a>
          ),
          action: (
            <div>
                <PencilFill
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowAddLeadershipCouncil(true);
                    setLeadershipCouncilToEdit(item);
                  }}
                  title="Edit"
                />
            
                <TrashFill
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(item._id)}
                  title="Delete"
                />
            </div>
          ),
        }));
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch(() => {});
  };

  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddCity
        show={showAddLeadershipCouncil}
        StateId={id}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getCities();
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `city/delete-city/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getCities();
            });
          }
        }}
        message="Are you sure you want to delete this city?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
             <button
              type="button"
              onClick={() => navigate(-1)}
              className="d-flex align-items-center bg-transparent border-0 fw-bold"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "8px" }}
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
              Back
            </button>
            <div className="page-title"> {stateName ? `${stateName} → Cities` : "Cities"} </div>

              <CustomButton
                isLoading={false}
                label="Add"
                onClick={() => {
                  setLeadershipCouncilToEdit(null);
                  setShowAddLeadershipCouncil(true);
                }}
                style={{ width: 100 }}
              />
          
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                  getCities(e.target.value, type);
                }}
              />
            </div>
          </div>

          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default Cities;
